import { useState, useEffect } from 'react'
import { FiRefreshCw, FiAlertCircle, FiCalendar, FiPrinter } from 'react-icons/fi'
import toast from 'react-hot-toast'
import api from '../utils/api'
import { useAuth } from '../App'
import AlberoDetayModal from '../components/AlberoDetayModal'

const fmt = (v) => (v == null || isNaN(v)) ? '0,00' : Number(v).toLocaleString('tr-TR', { minimumFractionDigits: 2, maximumFractionDigits: 2 })
const iso = (d) => d.toISOString().slice(0, 10)

export default function GonderilmeyenFaturalar() {
  const { selectedCompanyId } = useAuth()
  const [tarihBas, setTarihBas] = useState(() => { const d = new Date(); d.setDate(1); return iso(d) })
  const [tarihBit, setTarihBit] = useState(() => iso(new Date()))
  const [cari, setCari] = useState('')
  const [saticiKod, setSaticiKod] = useState('')
  const [saticilar, setSaticilar] = useState([])
  const [data, setData] = useState(null)
  const [loading, setLoading] = useState(false)
  const [modal, setModal] = useState(null)

  useEffect(() => {
    api.get('/albero/saticilar').then(r => setSaticilar(r.data.saticilar || [])).catch(() => {})
    load()
  }, [selectedCompanyId])

  const load = async () => {
    setLoading(true)
    try {
      const { data: r } = await api.get('/albero/gonderilmeyen-faturalar', {
        params: { tarih_bas: tarihBas, tarih_bit: tarihBit, cari: cari || undefined, satici_kod: saticiKod || undefined }
      })
      setData(r)
    } catch (e) {
      toast.error(e.response?.data?.detail || 'Liste yüklenemedi')
    }
    setLoading(false)
  }

  return (
    <div className="p-4 max-w-[1300px] mx-auto">
      <div className="bg-gradient-to-r from-slate-800 to-slate-700 rounded-xl p-4 mb-4 text-white no-print">
        <div className="flex items-center justify-between flex-wrap gap-2 mb-3">
          <h1 className="text-lg font-bold flex items-center gap-2"><FiAlertCircle size={18} /> Gönderilmeyen E-Faturalar</h1>
          <button onClick={() => window.print()} className="flex items-center gap-1 bg-white/20 hover:bg-white/30 px-3 py-1.5 rounded text-xs">
            <FiPrinter size={12} /> Yazdır
          </button>
        </div>
        <div className="flex items-center gap-2 flex-wrap text-xs">
          <FiCalendar size={13} />
          <input type="date" value={tarihBas} onChange={e => setTarihBas(e.target.value)}
            className="bg-white/10 border border-white/20 rounded px-2 py-1 text-white" />
          <span>-</span>
          <input type="date" value={tarihBit} onChange={e => setTarihBit(e.target.value)}
            className="bg-white/10 border border-white/20 rounded px-2 py-1 text-white" />
          <input value={cari} onChange={e => setCari(e.target.value)} placeholder="Cari ara..."
            className="bg-white/10 border border-white/20 rounded px-2 py-1 text-white placeholder-white/50 w-40" />
          <select value={saticiKod} onChange={e => setSaticiKod(e.target.value)}
            className="bg-white/10 border border-white/20 rounded px-2 py-1 text-white [&>option]:text-black">
            <option value="">Tüm satıcılar</option>
            {saticilar.map((s, i) => <option key={i} value={s.KOD}>{s.AD}</option>)}
          </select>
          <button onClick={load} disabled={loading}
            className="flex items-center gap-1 bg-white/20 hover:bg-white/30 px-3 py-1 rounded">
            <FiRefreshCw size={11} className={loading ? 'animate-spin' : ''} /> Listele
          </button>
        </div>
      </div>

      {data && (
        <div className="flex items-center gap-4 mb-3 text-sm">
          <div className="bg-white dark:bg-gray-800 rounded-lg border dark:border-gray-700 px-4 py-2">
            <span className="text-gray-400 text-xs">Adet: </span><span className="font-bold text-red-600">{data.adet}</span>
          </div>
          <div className="bg-white dark:bg-gray-800 rounded-lg border dark:border-gray-700 px-4 py-2">
            <span className="text-gray-400 text-xs">Toplam: </span><span className="font-bold text-blue-700 dark:text-blue-400">{fmt(data.toplam)} TL</span>
          </div>
        </div>
      )}

      <div className="bg-white dark:bg-gray-800 rounded-xl shadow-sm border dark:border-gray-700 overflow-hidden">
        <div className="overflow-auto" style={{ maxHeight: '72vh' }}>
          <table className="w-full text-xs">
            <thead className="sticky top-0 bg-gray-100 dark:bg-gray-700 text-gray-600 dark:text-gray-200 text-[10px] uppercase">
              <tr>
                <th className="text-left px-2 py-2">Fat. No</th>
                <th className="text-left px-2 py-2">Tarih</th>
                <th className="text-left px-2 py-2">Cari</th>
                <th className="text-left px-2 py-2">Satıcı</th>
                <th className="text-left px-2 py-2">Tip</th>
                <th className="text-right px-2 py-2">Tutar</th>
                <th className="text-left px-2 py-2">Durum</th>
              </tr>
            </thead>
            <tbody>
              {(data?.faturalar || []).map((f, i) => (
                <tr key={i} onClick={() => setModal({ type: 'fatura', fatno: f.FATNO })}
                  className="border-b dark:border-gray-700/50 cursor-pointer hover:bg-blue-50 dark:hover:bg-blue-900/20">
                  <td className="px-2 py-1.5 font-medium text-blue-600 dark:text-blue-400">{f.FATNO}</td>
                  <td className="px-2 py-1.5 whitespace-nowrap">{f.TARIH}</td>
                  <td className="px-2 py-1.5 truncate max-w-[280px]" onClick={e => { e.stopPropagation(); setModal({ type: 'cari', blcari: f.BLCARI, unvan: f.CARI }) }}>
                    <span className="hover:underline">{f.CARI}</span>
                  </td>
                  <td className="px-2 py-1.5 text-gray-500">{f.SATICI}</td>
                  <td className="px-2 py-1.5 text-gray-500">{f.TIP}</td>
                  <td className="text-right px-2 py-1.5 font-medium">{fmt(f.TOPLAM)}</td>
                  <td className="px-2 py-1.5 text-orange-600 dark:text-orange-400 text-[11px]">{f.EF_DURUM || 'Hiç gönderilmemiş'}</td>
                </tr>
              ))}
              {data && data.faturalar.length === 0 && (
                <tr><td colSpan={7} className="text-center text-gray-400 py-16">Gönderilmemiş fatura yok 🎉</td></tr>
              )}
            </tbody>
          </table>
        </div>
      </div>

      {modal && <AlberoDetayModal initial={modal} onClose={() => setModal(null)} />}
    </div>
  )
}
